import { motion } from "motion/react";

export type StepId = 1 | 2 | 3;
const LABELS: Record<StepId, string> = { 1: "Song", 2: "Cut", 3: "Player" };

export function StepHeader({ current, onJump }: { current: StepId; onJump: (s: StepId) => void }) {
  return (
    <nav className="glass steps" aria-label="Progress">
      {([1, 2, 3] as StepId[]).map((s) => {
        const state = s === current ? "active" : s < current ? "done" : "";
        return (
          <motion.button
            key={s} type="button" className={`step ${state}`} aria-current={s === current ? "step" : undefined}
            disabled={s > current} onClick={() => onJump(s)} whileTap={{ scale: 0.95 }} layout
          >
            <span className="n">{s < current ? "✓" : s}</span>
            {LABELS[s]}
          </motion.button>
        );
      })}
    </nav>
  );
}
